import $ from 'jquery';

const getCountdownItemHtml = (D, H, M, S) => `
  <div class="d-flex">
    <div class="el-content-countdown-item"><span class="el-content-countdown-item__num">00</span><span class="el-content-countdown-item__text">${D}</span></div>
    <div class="el-content-countdown-item"><span class="el-content-countdown-item__num">00</span><span class="el-content-countdown-item__text">${H}</span></div>
    <div class="el-content-countdown-item"><span class="el-content-countdown-item__num">00</span><span class="el-content-countdown-item__text">${M}</span></div>
    <div class="el-content-countdown-item"><span class="el-content-countdown-item__num">00</span><span class="el-content-countdown-item__text">${S}</span></div>
  </div>`;

const getDiff = countdown => {
  let [d, h, m, s] = [0, 0, 0, 0]; //时间默认值
  if (countdown > 0) {
    d = parseInt(countdown / 60 / 60 / 24);
    h = parseInt((countdown / 60 / 60) % 24);
    m = parseInt((countdown / 60) % 60);
    s = parseInt(countdown % 60);
  }
  if (d < 10) d = '0' + d;
  if (h < 10) h = '0' + h;
  if (m < 10) m = '0' + m;
  if (s < 10) s = '0' + s;
  return [d, h, m, s];
};

export default class Countdown {
  constructor($el, countdownEnd, countdownStart, countdownText = '天|时|分|秒') {
    if (!$el || !countdownEnd) return;
    this.$el = $el;
    this.countdownText = countdownText.split('|');
    this.endTime = +new Date(countdownEnd);
    this.startTime = countdownStart ? +new Date(countdownStart) : +new Date();
    this.countdown = (this.endTime - this.startTime) / 1000;
    this.init();
  }

  init() {
    const el = this.$el[0];
    if (el._countdownInit) return;
    el._countdownInit = true;
    this.insertDOM();
  }

  insertDOM() {
    const { $el, countdownText } = this;
    const [D, H, M, S] = countdownText;
    const $countdownItem = $(getCountdownItemHtml(D, H, M, S));
    $el.append($countdownItem);
    const $nums = $countdownItem.find('.el-content-countdown-item__num');
    this.showNums($nums, this.countdown);
    let timer = setInterval(() => {
      if (this.countdown <= 0) clearInterval(timer);
      this.showNums($nums, this.countdown);
      this.countdown--;
    }, 1000);
  }

  showNums($nums, countdown) {
    let diff = getDiff(countdown);
    $nums.each((i, el) => {
      el.innerText = diff[i];
    });
  }
}
